import React from "react";
import { motion } from "framer-motion";

const Alert = () => {
  return (
    <div className="flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: -15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="relative flex items-center gap-4 px-6 py-2 rounded-xl border border-green-400 bg-green-900/30 backdrop-blur-md shadow-[0_0_25px_rgba(74,222,128,0.4)] text-green-100 font-bold "
      >
        <div className="absolute -inset-[1px] rounded-xl border border-green-500/30 blur-[3px]"></div>
        <span className="relative flex items-center justify-center">
          <span className="absolute w-4 h-4 bg-green-400 rounded-full shadow-[0_0_15px_#4ade80,0_0_30px_#4ade80,0_0_45px_#4ade80] animate-pulse"></span>
        </span>{" "}
        <span className="relative z-10">
          Third Year and Final Year End Semester Notes are live Now....! 
        </span>
      </motion.div>
    </div>
  );
};

export default Alert;
